import _CircularProgress from "@mui/material/CircularProgress";
import _Close from "@mui/icons-material/Close";
import _Card from "@mui/material/Card";
import _CardContent from "@mui/material/CardContent";
import _ButtonBase from "@mui/material/ButtonBase";
import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import { useTheme } from '@mui/material/styles';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import foretViergeImage from '../assets/images/challenges/foret-vierge.png';
import grandeEpopeeImage from '../assets/images/challenges/grande-epopee.png';
import objectifLuneImage from '../assets/images/challenges/objectif-lune.png';
import premierDefiImage from '../assets/images/challenges/premier-defi.png';
import routeDeLaSoieImage from '../assets/images/challenges/route-de-la-soie.png';
import tourDeFranceImage from '../assets/images/challenges/tour-de-france.jpg';
import tourDeLaTerreImage from '../assets/images/challenges/tour-de-la-terre.png';
import { Button, ChallengeCard, RocketIcon, StickyBar } from '../components';
import { useCancellablePromise } from '../hooks';
import { Challenge } from '../models';
import { backendChallengeTypes, GeogroupService } from '../services';
const startDate = moment().add(1, 'month').startOf('month');
const endDate = moment().add(1, 'month').endOf('month');
export function ChallengesModelForm({
  Link,
  prevPath,
  currentPartner,
  drawerWidth,
  onRedirect
}) {
  const [isSubmitting, setSubmitting] = useState(false);
  const {
    t
  } = useTranslation();
  const [models] = useState([new Challenge(1, 'traveledDistance', 'global', 'all', startDate, endDate, 'Premier défi', 'Un premier défi : parcourir ensemble 1000 kilomètres !', premierDefiImage, null, 0, 0, 1000000, 'published', null, null), new Challenge(2, 'traveledDistance', 'global', 'all', startDate, endDate, 'Le Tour de France', "Parcourez collectivement l'équivalent du parcours de la Grande Boucle !", tourDeFranceImage, null, 0, 0, 3500000, 'published', null, null), new Challenge(3, 'traveledDistance', 'global', 'all', startDate, endDate, 'Forêt vierge', "7000km, c'est la longueur du plus long fleuve du monde : l'Amazone !", foretViergeImage, null, 0, 0, 7000000, 'published', null, null), new Challenge(4, 'traveledDistance', 'global', 'all', startDate, endDate, 'La Route de la Soie', 'Suivez les routes envoûtantes de la Route de la Soie en pédalant 12 000 kilomètres !', routeDeLaSoieImage, null, 0, 0, 12000000, 'published', null, null), new Challenge(5, 'traveledDistance', 'global', 'all', startDate, endDate, 'La Grande Épopée', 'Parcourez la distance de la Muraille de Chine en pédalant 21 196 kilomètres !', grandeEpopeeImage, null, 0, 0, 21196000, 'published', null, null), new Challenge(6, 'traveledDistance', 'global', 'all', startDate, endDate, 'Tour de la Terre à vélo', "Prêts à relever le défi de pédaler l'équivalent d'un tour de la Terre ?", tourDeLaTerreImage, null, 0, 0, 40075000, 'published', null, null), new Challenge(7, 'traveledDistance', 'global', 'all', startDate, endDate, 'Objectif Lune !', "Roulez pour atteindre la Lune ! L'objectif collectif est fixé à 384 400 km !", objectifLuneImage, null, 0, 0, 384400000, 'published', null, null)]);
  const [selectedModelId, selectModelId] = useState(models[0].id);
  const {
    palette
  } = useTheme();
  const {
    enqueueSnackbar
  } = useSnackbar();
  const {
    cancellablePromise,
    cancelPromises
  } = useCancellablePromise();
  useEffect(() => {
    return () => cancelPromises();
  }, []);
  async function handleSubmit() {
    if (!currentPartner) return;
    const model = models.find(({
      id
    }) => id === selectedModelId);
    if (!model) return;
    const {
      title,
      description,
      startDate,
      endDate,
      type,
      targetValue
    } = model;
    setSubmitting(true);
    try {
      let photo;
      if (model.photo) {
        const res = await fetch(model.photo, {
          method: 'GET',
          headers: {
            'Content-Type': 'image/png'
          }
        });
        const blob = await res.blob();
        photo = new File([blob], model.photo.slice(model.photo.lastIndexOf('/') + 1));
      }
      await cancellablePromise(GeogroupService.addChallenge(currentPartner, {
        title,
        description,
        start_datetime: moment(startDate).startOf('day').format(),
        end_datetime: moment(endDate).endOf('day').format(),
        target_type: backendChallengeTypes[type],
        trace_type: type === 'homeWorkJourneysCount' ? 'COMMUTING' : 'ALL',
        target_value: targetValue
      }, photo, {
        expectedStatus: 201
      }));
      enqueueSnackbar(t('commons.challenge_post.form.success'));
      onRedirect();
    } catch (err) {
      if (typeof err === 'object' && err && 'status' in err && err.status === 200 && 'message' in err && typeof err.message === 'object' && err.message && 'id' in err.message) {
        enqueueSnackbar(t('commons.challenge_post.form.server_error_already_exists'), {
          variant: 'error'
        });
        onRedirect();
      } else if (!(err instanceof Error) || err?.name !== 'CancelledPromiseError') {
        enqueueSnackbar(t('commons.challenge_post.form.server_error'), {
          variant: 'error'
        });
        setSubmitting(false);
      }
    }
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Box, {
    alignSelf: "stretch",
    marginBottom: "58px"
  }, /*#__PURE__*/React.createElement(_Card, {
    elevation: 0,
    sx: {
      alignSelf: 'stretch',
      borderRadius: 4
    }
  }, /*#__PURE__*/React.createElement(_CardContent, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      gap: 3,
      padding: 3
    }
  }, /*#__PURE__*/React.createElement(_Box, {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: {
      xs: 'column',
      md: 'row'
    },
    gap: 2,
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(_Typography, {
    fontWeight: 600,
    variant: "h6"
  }, t('commons.challenge_post.form.title_creation_model'))), /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexWrap: "wrap",
    gap: 2
  }, models.map(challenge => /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    key: challenge.id,
    width: {
      xs: '100%',
      md: 'calc((100% - 16px) / 2)',
      lg: 'calc((100% - 32px) / 3)'
    }
  }, /*#__PURE__*/React.createElement(_ButtonBase, {
    disabled: isSubmitting,
    onClick: () => selectModelId(challenge.id),
    sx: {
      borderRadius: 4,
      '.challenge-card': {
        cursor: 'pointer'
      }
    }
  }, /*#__PURE__*/React.createElement(ChallengeCard, {
    disableLink: true,
    isModel: true,
    challenge: challenge,
    containerProps: challenge.id === selectedModelId ? {
      border: `2px solid ${palette.primary.main}`
    } : {
      border: `1px solid #e3e7ee`,
      margin: '1px'
    }
  })))))))), /*#__PURE__*/React.createElement(StickyBar, {
    drawerWidth: drawerWidth
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    component: Link,
    disabled: isSubmitting,
    size: "large",
    startIcon: /*#__PURE__*/React.createElement(_Close, null),
    sx: {
      borderRadius: '8px !important'
    },
    to: prevPath,
    variant: "outlined"
  }, t('commons.actions.cancel')), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    disabled: isSubmitting,
    onClick: handleSubmit,
    size: "large",
    startIcon: isSubmitting ? /*#__PURE__*/React.createElement(_CircularProgress, {
      color: "inherit",
      size: 16,
      thickness: 4
    }) : /*#__PURE__*/React.createElement(RocketIcon, null),
    sx: {
      borderRadius: '8px !important'
    },
    variant: "contained"
  }, t('commons.challenge_post.actions.launch')))));
}